<template>
    <div class="card" id="Device" style="direction: rtl">
        <div class="card-header" style="display:flex">
            <h3 class="card-title">مدیریت خودروها</h3>
            <div style="flex-grow:1">

            </div>
            <CButton    color="outline-primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="[isShowAdvancedSearch=!isShowAdvancedSearch,$store.state.Vehicles.RequestResponse=[]]"><CIcon name="cil-search"/>&nbsp;&nbsp;جستجوی پیشرفته </CButton>
        </div>
        <div class="card-body" style="display:flex;flex-direction:column;gap:10px">
            <CCollapse  :show="isShowAdvancedSearch"  :duration="300">
                <CCardBody style="display:flex;flex-direction:column;gap:10px">
                    <div style="display:flex;gap:10px">
                        <CInput v-model="AdvancedSearch.FleetName" style="flex-grow: 1;" label="نام خط"/>
                        <CInput v-model="AdvancedSearch.VehicleName" style="flex-grow: 1;" label="نام خودرو"/>
                        <CInput v-model="AdvancedSearch.Type" style="flex-grow: 1;" label="نوع خودرو"/>
                    </div>
                    <div style="display:flex;gap:10px">
                        <CInput v-model="AdvancedSearch.VIN" style="flex-grow: 1;" label="VIN"/>
                        <CInput v-model="AdvancedSearch.Plate" style="flex-grow: 1;" label="شناسه دستگاه"/>
                        <CInput v-model="AdvancedSearch.MakeYear" style="flex-grow: 1;"  label="سال ساخت"/>
                    </div>
                    <div style="display:flex;gap:10px">
                        <div style="flex-grow: 1;"></div>
                            <CButton v-if="$store.state.InlineLoading.Vehicle_AdvancedSearch" disabled=""    color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px">
                                <b-spinner small></b-spinner>
                                <span class="sr-only">درحال جستجو...</span>
                                </CButton>
                            <CButton v-else    color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="Vehicle_AdvancedSearch()"><CIcon name="cil-search"/>&nbsp;&nbsp;جستجو </CButton>
                        </div>
                </CCardBody>
            </CCollapse>
            <div class="input-group" style="direction: rtl" v-if="!isShowAdvancedSearch">
                <span class="input-group-text" style="min-width: 100px">انتخاب خط</span>
                <input class="form-control" disabled  v-model="Fleet.FleetName" type="text"   aria-describedby="basic-addon1">
                <CButton @click="DialogSelectFleet = true" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">انتخاب</CButton>
            </div>
            <CDataTable
                    :hover="true"
                    :border="true"
                    
                    :striped="true"
                    :small="true"
                    :items="$store.state.Vehicles.RequestResponse"
                    :fields="fields"
                    :fixed="true"
                    :loading="false"
                    :items-per-page="10"
                    pagination
                    :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"
            >


                <template #Rows="{index}">
                    <td>
                        {{index+1}}
                    </td>
                </template>
                <template #Action="{item}">
                    <td>
                        <CButton   color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="EditVehicle(item)">ویرایش</CButton>
                    </td>
                </template>
                <template #Serial="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.Serial===null" color="warning" > موجود نیست</CBadge>
                        <CBadge v-else-if="item.Serial.length<6" color="warning"> موجود نیست</CBadge>
                        <CBadge v-else color="info" v-text="item.Serial"> </CBadge>
                    </td>
                </template>
                <template #Model="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.Model===null" color="warning" >نا مشخص</CBadge>
                        <CBadge v-else-if="item.Model.length<6" color="warning"> نا مشخص</CBadge>
                        <CBadge v-else color="info" v-text="item.Model"> </CBadge>
                    </td>
                </template>
                <template #Plate="{item}">
                    <td style="font-size: 16px">
                        <div style="width: 200px;height: 45px;background: url('/images/plate.png');direction: ltr;display:flex;align-items: center;">
                            <span class="p1" v-text="GetPlateSplit(item.Plate,1)" style="color: black;font-size: 24px;margin-left: 24px;font-weight:bold;font-family: BTitr;width:35px;text-align:center"> </span>
                            <span class="p2" v-text="GetPlateSplit(item.Plate,2)" style="color: black;font-size: 24px;margin-left: 3px;font-weight:bold;font-family: BTitr;width:40px;text-align:center"></span>
                            <span class="p3" v-text="GetPlateSplit(item.Plate,3)" style="color: black;font-size: 24px;margin-left: 0px;font-weight:bold;font-family: BTitr;width:50px;text-align:center"></span>
                            <span class="p4" v-text="GetPlateSplit(item.Plate,4)" style="color: black;font-size: 24px;margin-left: 10px;font-weight: bold;font-family: BTitr;margin-top: 4px;width:35px;text-align:center"></span>
                        </div>
                        <!-- <CBadge v-else color="info" v-text="item.Plate"> </CBadge> -->
                    </td>
                </template>
                <template #Type="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.Type===null" color="warning" >نا مشخص</CBadge>
                        <CBadge v-else-if="item.Type.length<6" color="warning"> نا مشخص</CBadge>
                        <span v-else ><img :src="'images/DeviceTypeImage/'+GetIcon(item.VehicleTypeID)" alt=""><span v-text="item.Type"></span> </span>
                    </td>
                </template>
                <template #Description="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.Description===null" color="warning" >نا مشخص</CBadge>
                        <CBadge v-else-if="item.Description.length<6" color="warning"> نا مشخص</CBadge>
                        <CBadge v-else   color="info">{{item.Description}}</CBadge>
                    </td>
                </template>

            </CDataTable>
        </div>
        <div class="card-footer" style="display:flex;direction:ltr;gap:10px;">

            <MPrint 
                v-if="$store.state.Vehicles.RequestResponse.length>0"
                :data="$store.state.Vehicles.RequestResponse"
                label="PDF" 
                title="اتوبوس ها" 
                :From="FromDate"
                :TO="ToDate"
                :fields="fields">
            </MPrint> 
        </div>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogSelectFleet"
        >
            <div style="direction: rtl;text-align: right;diaply:flex;flex-direction:column">
                <CInput v-model="TextSearchFleet" placeholder="جستجو" label="نام خط"/>
                <div >
                    <select class="form-select"  size="10" v-model="indexFleet">
                        <option v-for="(fleet,index) in GetFleetsSearch($store.state.Fleets.RequestResponse,TextSearchFleet)" :value="index" v-text="fleet.FleetName" v-bind:key="index"></option>
                    </select>
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; انتخاب خط </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSelectFleet = false" color="danger">بستن</CButton>
                <CButton @click="SelectFleet()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>

        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                size="lg"
                :show.sync="DialogEditVehicle"
        >
        <CRow>
            <CCol>
                <CInput
                    label="شماره شناسایی خودرو"
                        v-model="Vehicle.VehicleID"
                        disabled
                    />
            </CCol>
            <CCol>
                <CInput
                    label="نام خودرو"
                        v-model="Vehicle.VehicleName"
                    />
            </CCol>
        </CRow>
        <CRow>
            <CCol>
                <CRow>
                    <label for="">نوع خودرو</label>
                </CRow>
                <CRow>
                    <div class="input-group" style="direction: rtl">
                        <p  class="form-control" ><img style="margin-top: -5px" :src="'images/DeviceTypeImage/'+GetIcon(Vehicle.VehicleTypeID)" alt=""> <span >{{Vehicle.Type}}</span></p>
                        <CButton @click="DialogSelectIcon=true" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">انتخاب</CButton>
                    </div>
                </CRow>
            </CCol>
            <CCol>
                <label for="" style="color:white"></label>
                <div style="width: 200px;height: 45px;background: url('/images/plate.png');direction: ltr;display:flex;align-items: center;">
                    <input ref="p1" maxlength="2"  class="p1" type="text" v-model="Vehicle.p1" style="color: black;font-size: 24px;margin-left: 24px;font-weight:bold;font-family: BTitr;width:35px;text-align:center;background: #00000000;border: 0;">
                    <input ref="p2" maxlength="1"  class="p2" type="text" disabled v-model="Vehicle.p2" style="color: black;font-size: 24px;margin-left: 3px;font-weight:bold;font-family: BTitr;width:40px;text-align:center;background: #00000000;border: 0;">
                    <input ref="p3" maxlength="3"  class="p3" type="text" v-model="Vehicle.p3" style="color: black;font-size: 24px;margin-left: 0px;font-weight:bold;font-family: BTitr;width:50px;text-align:center;background: #00000000;border: 0;">
                    <input ref="p4" maxlength="2"  class="p4" type="text" v-model="Vehicle.p4" style="color: black;font-size: 24px;margin-left: 10px;font-weight: bold;font-family: BTitr;margin-top: 4px;width:35px;text-align:center;background: #00000000;border: 0;">
                </div>
            </CCol>
        </CRow>
        <CRow>
            <CCol>
                <CInput
                    label="مدل"
                    ref="Model"
                        v-model="Vehicle.Model"
                    />
            </CCol>
            <CCol>
                <CInput
                    label="سریال"
                        v-model="Vehicle.Serial"
                    />
            </CCol>
        </CRow>
        <CRow>
            <CCol>
                <CInput
                    label="VIN"
                        v-model="Vehicle.VIN"
                    />
            </CCol>
            <CCol>
                
            </CCol>
        </CRow>
        <CRow>
            <CCol>
                <CTextarea
                    label="توضیحات"
                        v-model="Vehicle.Description"
                    />
            </CCol>
        </CRow>

            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; ویرایش خودرو </h4>

            </template>
            <template #footer>
                <CButton @click="DialogEditVehicle = false" color="warning">انصراف</CButton>
                <CButton  color="info" @click="UpdateVehicle">&nbsp;&nbsp;  به روز رسانی </CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                size="sm"
                :show.sync="DialogSelectIcon"
        >
            <div style="direction: rtl;text-align: right">

                <div v-for="(type,index) in $store.state.VehicleTypes.RequestResponse" v-bind:key="index">
                    <div v-if="type.ID===indexIcon"  style="background:deepskyblue;margin-top: 5px;color: white;border: 2px solid white">
                        <img style="margin-right: 10px" :src="'images/DeviceTypeImage/'+type.Icon" alt=""><span >{{type.Name}}</span>
                    </div>
                    <div v-else  style="background: #000;margin-top: 5px;color: white;border: 2px solid black" @click="indexIcon=type.ID">
                        <img style="margin-right: 10px" :src="'images/DeviceTypeImage/'+type.Icon" alt=""><span >{{type.Name}}</span>
                    </div>
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; انتخاب آیکون </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSelectIcon = false" color="danger">بستن</CButton>
                <CButton @click="SelectIcon()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>
        <div class="toast fade show" v-if="Toast.show" role="alert" aria-live="assertive" aria-atomic="true"  style="position: fixed;bottom: 10px;left:10px;direction: rtl;text-align: right">
            <div class="toast-header">
                <svg class="docs-placeholder-img rounded me-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
                    <rect width="100%" height="100%" fill="green"></rect>
                </svg><strong class="me-auto" style="float: right;width: auto">{{Toast.title}}</strong>
            </div>
            <div class="toast-body">{{Toast.message}}</div>
        </div>
    </div>
</template>

<script>
    import Constant from '@/assets/Constants'

    export default {
        name: "Vehicle",
        data(){
            return {
                Toast:{
                    message:'',
                    title:"",
                    duration:3000,
                    show:false,
                },
                User:null,
                TextSearchFleet:"",
                isShowAdvancedSearch:false,
                Vehicles: [],
                VehicleTypes: [],
                VehicleType:{},
                indexFleet:0,
                indexIcon:-1,
                Fleet:{FleetName:""},
                DialogSelectFleet:false,
                DialogEditVehicle:false,
                DialogSelectIcon:false,
                Vehicle:{
                    p1:'00',
                    p3:'000',
                    p4:'00',
                },
                AdvancedSearch:{
                    FleetName:'',
                    VehicleName:'',
                    Type:'',
                    VIN:'',
                    Plate:'',
                    MakeYear:'',
                },
                fields:[{"key":"Rows","label":"ردیف"},{"key":"VehicleID","label":"آی دی خودرو"},{"key":"VehicleName","label":"نام خودرو"},{"key":"Plate","label":"پلاک"},{"key":"Type","label":"نوع خودرو"},{"key":"Model","label":"مدل"},{"key":"Serial","label":"سریال"},{"key":"VIN","label":"VIN"},{"key":"Description","label":"توضیحات"},{"key":"Action","label":"عملکرد"}],
                
            }
        },
        computed:{
            ReadPlatePart1(){
                return this.Vehicle.p1;
            },
            ReadVehicle_Update(){
                return this.$store.state.Vehicle_Update;
            },

        },
        watch:{
            'Vehicle.p1'(newQuestion, oldQuestion){

                console.log(oldQuestion.length)
                console.log(newQuestion.length)
                if(newQuestion!==null && oldQuestion !==null){
                    if(oldQuestion.length!==2 && newQuestion.length===2){
                        console.log('yes')
                        this.$refs.p3.focus();
                        this.$refs.p3.select();
                    }
                }
            },
            'Vehicle.p3'(newQuestion, oldQuestion){

                console.log(oldQuestion.length)
                console.log(newQuestion.length)
                if(newQuestion!==null && oldQuestion !==null){
                    if(oldQuestion.length!==3 && newQuestion.length===3){
                        console.log('yes')
                        this.$refs.p4.focus();
                        this.$refs.p4.select();
                    }
                }
            },
            'Vehicle.p4'(newQuestion, oldQuestion){

                console.log(oldQuestion.length)
                console.log(newQuestion.length)
                if(newQuestion!==null && oldQuestion !==null){
                    if(oldQuestion.length!==2 && newQuestion.length===2){
                        console.log('yes')
                         //this.$refs.p4.focus();
                         //this.$refs.Model.select();
                    }
                }
            },
            ReadVehicle_Update(res){
                if(res.Status!==undefined){
                    if(res.Status){
                        if(res.RequestResponse[0].Message==='Successfully!'){
                            this.DialogEditVehicle=false;
                            this.GetVehicles();
                            this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'});
                        }
                        
                    }
                    
                }
                
            }
            // ReadPlatePart2(old){

            // },
            // ReadPlatePart4(old){

            // },
        },
        mounted() {
            if(this.$session.has("User")){
                this.User= this.$session.get("User");
                console.log("User-->"+this.User);
            }
            this.GetFleets();
            this.GetVehicleType();
            var plate='38ع215 - 83'
            this.GetPlateSplit(plate,1);

        },
        methods:{
            GetFleets(){
                this.$store.commit('FleetByUser')
            },
            GetVehicleType(){
                 this.$store.commit('VehicleType_GetAll')
            
            },
            SelectFleet()
            {
                var fleets=this.GetFleetsSearch(this.$store.state.Fleets.RequestResponse,this.TextSearchFleet);
                this.Fleet=fleets[this.indexFleet];
                this.DialogSelectFleet=false;
                this.GetVehicles();
            },
            GetVehicles(){
                this.$store.commit('Vehicle_GetByFleetID',{FleetID:this.Fleet.FleetID})
            },
            UpdateVehicle(){
                var plate=this.Vehicle.p1+this.Vehicle.p2+this.Vehicle.p3+' - '+this.Vehicle.p4
                var reg=/^[0-9]{2}[آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی][0-9]{3} - [0-9]{2}$/
                 if(reg.test(plate)){
                    var that=this;
                    this.$store.commit('Vehicle_Update',{
                        ID:this.Vehicle.VehicleID,
                        VehicleName:this.Vehicle.VehicleName,
                        VehicleTypeID:this.Vehicle.VehicleTypeID,
                        Type:this.Vehicle.Type,
                        Plate:plate,
                        Model:this.Vehicle.Model,
                        Serial:this.Vehicle.Serial,
                        YOM:this.Vehicle.YOM,
                        Description:this.Vehicle.Description,
                        VIN:this.Vehicle.VIN,
                    })
                
                }
                else{
                    this.$store.commit('ShowToast',{type:'error',message:'لطفا پلاک معتبر وارد نمایید'})
                }
                
            },
            EditVehicle(item){
                 this.Vehicle.Type=item.Type;
                 this.Vehicle.Serial=item.Serial;
                 this.Vehicle.Description=item.Description;
                 this.Vehicle.VehicleTypeID=item.VehicleTypeID;
                 this.Vehicle.YOM=item.YOM;
                 this.Vehicle.FleetID=item.FleetID;
                 this.Vehicle.Model=item.Model;
                 this.Vehicle.VehicleID=item.VehicleID;
                 this.Vehicle.VehicleName=item.VehicleName;
                 this.Vehicle.Plate=item.Plate;
                 this.Vehicle.VIN=item.VIN;
                this.DialogEditVehicle=true;
                var reg=/^[0-9]{2}[آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی][0-9]{3} - [0-9]{2}$/

                if(reg.test(this.Vehicle.Plate)){
                    this.Vehicle.p1=this.Vehicle.Plate.substring(0,2)
                    this.Vehicle.p2="ع"//data.substring(2,3)
                    this.Vehicle.p3=this.Vehicle.Plate.substring(3,6)
                    this.Vehicle.p4=this.Vehicle.Plate.substring(9,11)
                }
                else{
                    this.Vehicle.p1="00"
                    this.Vehicle.p2="ع"//data.substring(2,3)
                    this.Vehicle.p3="000"
                    this.Vehicle.p4="00"
                }
                 
            },
            SelectIcon(){
                var type=this.$store.state.VehicleTypes.RequestResponse[this.indexIcon - 1];
                this.DialogSelectIcon=false;
                this.VehicleType=type;
                this.Vehicle.Type=type.Name;
                this.Vehicle.VehicleTypeID=type.ID;
            },
            GetIcon(id){
                var icon="blueBus.png"
                for(var i=0;i<this.$store.state.VehicleTypes.RequestResponse.length;i++){
                    if(this.$store.state.VehicleTypes.RequestResponse[i].ID===id){
                        icon=this.$store.state.VehicleTypes.RequestResponse[i].Icon;
                        break
                    }
                }
                return icon;
            },
            GetPlateSplit(data,index){
                console.log(data)
                var reg=/^[0-9]{2}[آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی][0-9]{3} - [0-9]{2}$/
                var reg1=/^[0-9]{2}$/
                 var res= reg.test(data);
                
                 if(index===1){
                     if(reg.test(data)){
                         return data.substring(0,2)
                     }
                     else{
                         return '00'
                     }
                     
                 }
                 else if(index===2){
                     if(reg.test(data)){
                         return data.substring(2,3)
                     }
                     else{
                         return '-'
                     }
                     
                 }
                 else if(index===3){
                     if(reg.test(data)){
                         return data.substring(3,6)
                     }
                     else{
                         return '000'
                     }
                     
                 }
                 else if(index===4){
                     if(reg.test(data)){
                         return data.substring(9,11)
                     }
                     else{
                         return '00'
                     }
                     
                 }
            },
            GetFleetsSearch(fleets,txt){
                var items=[];
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    if(fleet.FleetName.toLowerCase().includes(txt.toLowerCase())){
                        items.push(fleet)
                    }
                }
                return items;
            },
            Vehicle_AdvancedSearch(){
                this.$store.commit('Vehicle_AdvancedSearch',{
                    UserID:2188,
                    FleetName:this.AdvancedSearch.FleetName,
                    Type:this.AdvancedSearch.Type,
                    VehicleName:this.AdvancedSearch.VehicleName,
                    VIN:this.AdvancedSearch.VIN,
                    Plate:this.AdvancedSearch.Plate,
                    MakeYear:this.AdvancedSearch.MakeYear
                });
            },
        }
    }
</script>

<style scoped>

</style>